// HomePage.js
import React from 'react';

function HomePage() {
  return (
    <div>
      <h2>Daily Chain</h2>
      <p>Daily Chain coming online soon!</p>
    </div>
  );
}

export default HomePage;
